import ScrollMagic from 'scrollmagic'

export default (function() {

  function init(scrollController) {

    // Large "quote" blocks
    const quoteContainers = Array.from(document.querySelectorAll('.content-quote-block'))
    const quoteLblContainers = quoteContainers.map((quoteBlock) => quoteBlock.querySelector('.c-lbl-container'))

    quoteContainers.forEach((quoteContainer, i) => {
      const height = quoteContainers[i].offsetHeight

      let lineScene = new ScrollMagic.Scene({
        triggerElement: quoteContainer,
        triggerHook: 'onEnter',
        offset: height * -.3
      })
      .setClassToggle(quoteContainers[i], 'animate')
      .addTo(scrollController);

      let quoteScene = new ScrollMagic.Scene({
        triggerElement: quoteContainer,
        triggerHook: 'onEnter',
        offset: height * -.1
      })
      .setClassToggle(quoteLblContainers[i], 'reveal')
      .addTo(scrollController);
    })
  }

  return {
    init
  }

})();
